// Sprint 35.0 — Capa de persistencia local (IndexedDB) sin dependencias externas.
// Dos almacenes:
//  - "outbox": bandeja de salida de POST fallidos por red (sobrevive a refrescos/apagones).
//  - "cache":  snapshots de tarifas y autos en patio por sucursal (para cobro offline).

const DB_NAME = "parknova_offline";
const DB_VERSION = 1;
const STORE_OUTBOX = "outbox";
const STORE_CACHE = "cache";

let _dbPromise = null;

function openDB() {
  if (_dbPromise) return _dbPromise;
  _dbPromise = new Promise((resolve, reject) => {
    if (typeof indexedDB === "undefined") {
      reject(new Error("IndexedDB no disponible"));
      return;
    }
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE_OUTBOX)) {
        db.createObjectStore(STORE_OUTBOX, { keyPath: "id" });
      }
      if (!db.objectStoreNames.contains(STORE_CACHE)) {
        db.createObjectStore(STORE_CACHE, { keyPath: "key" });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  return _dbPromise;
}

function tx(store, mode, fn) {
  return openDB().then(
    (db) =>
      new Promise((resolve, reject) => {
        const t = db.transaction(store, mode);
        const os = t.objectStore(store);
        let result;
        try {
          result = fn(os);
        } catch (e) {
          reject(e);
          return;
        }
        t.oncomplete = () => resolve(result && result.result !== undefined ? result.result : result);
        t.onerror = () => reject(t.error);
        t.onabort = () => reject(t.error);
      }),
  );
}

// ---- Outbox ----
export async function dbPut(record) {
  return tx(STORE_OUTBOX, "readwrite", (os) => os.put(record));
}
export async function dbDelete(id) {
  return tx(STORE_OUTBOX, "readwrite", (os) => os.delete(id));
}
export async function dbGetAll() {
  return openDB().then(
    (db) =>
      new Promise((resolve, reject) => {
        const t = db.transaction(STORE_OUTBOX, "readonly");
        const req = t.objectStore(STORE_OUTBOX).getAll();
        req.onsuccess = () => resolve(req.result || []);
        req.onerror = () => reject(req.error);
      }),
  );
}
export async function dbCount() {
  return openDB().then(
    (db) =>
      new Promise((resolve, reject) => {
        const t = db.transaction(STORE_OUTBOX, "readonly");
        const req = t.objectStore(STORE_OUTBOX).count();
        req.onsuccess = () => resolve(req.result || 0);
        req.onerror = () => reject(req.error);
      }),
  );
}

// ---- Cache (tarifas / patio) ----
export async function cachePut(key, value) {
  return tx(STORE_CACHE, "readwrite", (os) => os.put({ key, value, ts: Date.now() }));
}
export async function cacheGet(key) {
  return openDB().then(
    (db) =>
      new Promise((resolve, reject) => {
        const t = db.transaction(STORE_CACHE, "readonly");
        const req = t.objectStore(STORE_CACHE).get(key);
        req.onsuccess = () => resolve(req.result ? req.result.value : null);
        req.onerror = () => reject(req.error);
      }),
  );
}
